import type { EstimatedDeliveryDateBlockProps } from "./types";
import { EstimatedDeliveryDateEmailRenderer } from "./email";
import { EmailComponentWrapper } from "../../utils/email-component-wrapper";

export function EstimatedDeliveryDateEditorRenderer(
  props: EstimatedDeliveryDateBlockProps,
) {
  return (
    <EmailComponentWrapper shop={props.shop}>
      <EstimatedDeliveryDateEmailRenderer {...props} />
    </EmailComponentWrapper>
  );
}
